import { Plugin } from '@nuxt/types'
import { FelicaService } from '@/services/FelicaService'

declare module 'vue/types/vue' {
  interface Vue {
    $felica: FelicaService
  }
}

declare module '@nuxt/vue-app' {
  interface NuxtAppOptions {
    $felica: FelicaService
  }
}

const plugin: Plugin = (context, inject) => {
  inject('felica', new FelicaService())
}

export default plugin
